angular.module('impactx.product').controller('ProductContactsCtrl', [
    '$scope',
    '$mdDialog',
    'themeFactory',
    'dataGen',
    'data',
    'headerLabel',
    'confirmLabel',
    'abortLabel',
    'noSelectedItemMessage',
    'requiredLabel',
    ProductContactsCtrl]);

function ProductContactsCtrl($scope, $mdDialog, themeFactory, dataGen, data, headerLabel, confirmLabel, abortLabel, noSelectedItemMessage, requiredLabel)
{
    $scope.showMust = true;
    $scope.theme = themeFactory.getTheme();
    //copy main data so we can revert it.
    $scope.contactData = JSON.parse(JSON.stringify(data.contactData));
    $scope.confirmLabel = confirmLabel;
    $scope.abortLabel = abortLabel;
    $scope.headerLabel = headerLabel;
    $scope.noSelectedItemMessage = noSelectedItemMessage;
    $scope.requiredLabel = requiredLabel;
    $scope.contactData.removedContacts = [];
    this.cancel = function ()
    {
        $mdDialog.cancel();
    };

    this.confirm = function ()
    {
        data.contactData = $scope.contactData;
        $mdDialog.hide();
    };

    this.addContact = function()
    {
        var tempContact = JSON.parse(JSON.stringify($scope.contactData.templateContact));
        $scope.contactData.contacts.push(tempContact);
    };

    this.removeContact = function(index)
    {
        $scope.contactData.removedContacts.push($scope.contactData.contacts.splice(index, 1)[0]);
    };

    this.getUserList = function(searchText)
    {
        return dataGen.getData({}, {searchText: searchText, proId: data.id}, "/product/contactuser", null, true).then(function(data) {
            return data.data.entries;
        });
    }
}